import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyAfSDzYx6dY8TNHUDiYr_TTLmPqS8BTG4g",
  authDomain: "champion-trader-89c37.firebaseapp.com",
  projectId: "champion-trader-89c37",
  storageBucket: "champion-trader-89c37.firebasestorage.app",
  messagingSenderId: "674492220385",
  appId: "1:674492220385:web:8872f9ae70e1e9f77f08a0"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
